import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// /* eslint-disable max-len */
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, FormControlLabel, TextField, } from '@mui/material';
import { CancelOutlined, CheckCircle } from '@mui/icons-material';
import Explanation from './Explanation';
const FillInTheBank = ({ answers, correctAnswer, setAnswer, isSubmit, userAnswers, setInputValue, inputValue, }) => {
    const [valueId, setValueId] = useState(null);
    const handleChange = (e) => {
        const newValue = e.target.value;
        setInputValue(newValue);
    };
    const setAnswerFn = (ev) => {
        const newValue = ev.target.value.toLowerCase();
        const selectedAnswer = answers.find((a) => (a.answerText.toLowerCase() === newValue));
        if (selectedAnswer) {
            setAnswer([selectedAnswer.id]);
            setValueId(selectedAnswer.id);
        }
        else {
            setAnswer(['5831e610-fcdc-4a35-84a9-3164c1e87d9r']);
            setValueId('5831e610-fcdc-4a35-84a9-3164c1e87d9r');
        }
        handleChange(ev);
    };
    const includeId = valueId !== null && answers.some((a) => a.id === valueId);
    return (_jsx(Box, { sx: { ml: '5%' }, children: _jsx(FormControlLabel, { sx: {
                width: '100%',
                border: (theme) => (userAnswers.includes(correctAnswer.id) && isSubmit
                    ? `2px solid ${theme.palette.contract.main}`
                    : ''),
                my: 4,
            }, name: correctAnswer.id, label: " ", labelPlacement: "end", "aria-labelledby": `label-${correctAnswer.id}`, control: (_jsxs(_Fragment, { children: [isSubmit && includeId && (_jsx(CheckCircle, { sx: { color: 'green', m: 1 } })), isSubmit && !includeId && (_jsx(CancelOutlined, { sx: { color: 'red', m: 1 } })), _jsx(TextField, { fullWidth: true, name: correctAnswer.id, placeholder: "Enter correct answer", value: inputValue, onChange: (ev) => setAnswerFn(ev), sx: {
                            width: '100%',
                        }, InputLabelProps: {
                            sx: { color: (t) => (t.portal.global.font.color) },
                        }, InputProps: {
                            'aria-describedby': `label-${correctAnswer.id}`,
                            sx: {
                                '& fieldset': {
                                    borderColor: isSubmit
                                        ? userAnswers.includes(correctAnswer.id)
                                            ? 'green'
                                            : 'red'
                                        : (t) => t.portal.global.font.color,
                                },
                            },
                        }, autoComplete: "off" }), isSubmit && Boolean(correctAnswer.explanation) && (_jsx(Explanation, { explanation: correctAnswer.explanation }))] })) }, correctAnswer.id) }));
};
export default observer(FillInTheBank);
//# sourceMappingURL=FillInTheBlank.js.map